import { render, staticRenderFns } from "./GoogleInsight.vue?vue&type=template&id=64b73148&scoped=true&"
import script from "./GoogleInsight.vue?vue&type=script&lang=js&"
export * from "./GoogleInsight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b73148",
  null
  
)

export default component.exports